/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/product/ingredients.js":
/*!******************************************************!*\
  !*** ./zrc/scripts/templates/product/ingredients.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n\n\nvar sectionType = 'product-ingredients-section';\nvar sectionConfig = {\n  onLoad() {\n    // Nodos que necesitaremos\n    this.$slider = this.container.querySelector('.product-ingredients-slider');\n    this.$prevButton = this.container.querySelector('.product-ingredients-arrow.prev');\n    this.$nextButton = this.container.querySelector('.product-ingredients-arrow.next');\n    this.$popup = this.container.querySelector('.product-ingredients-pop-up--card');\n    this.cards = this.container.querySelectorAll('.product-ingredients-card');\n    this.initCarousel();\n    this.showPopupCardClick();\n  },\n  initCarousel() {\n    // Función para inicilizar el slider de swatches\n\n    var carouselConfig = {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__.Navigation],\n      loop: false,\n      slidesPerView: 'auto',\n      centerInsufficientSlides: true,\n      navigation: {\n        prevEl: this.$prevButton,\n        nextEl: this.$nextButton\n      }\n    };\n\n    // inicializamos el slider\n    this.$slider = new swiper__WEBPACK_IMPORTED_MODULE_1__.default(this.$slider, carouselConfig);\n\n    // si el slider se mueve, cerramos el popup\n    this.$slider.on('setTranslate', this.closePopup.bind(this));\n    window.addEventListener('resize', this.closePopup.bind(this));\n  },\n  showPopupCardClick() {\n    // si no tenemos tarjeta, no hacemos nada\n    if (this.cards.length === 0) {\n      return;\n    }\n\n    // recorremos las tarjetas para  darles funcionalidad cuando les demos click\n    this.cards.forEach($card => {\n      var $buttonsCard = $card.querySelectorAll('.product-ingredients-card--icon-button');\n      $buttonsCard.forEach($button => {\n        $button.addEventListener('click', showPopup.bind(this));\n      });\n    });\n    function showPopup(event) {\n      // funcion para el manejo del popup\n\n      // Obtenemos los nodos que nos interensan\n      var $clickedButton = event.currentTarget;\n      // const $clickedCard = $clickedButton.parentNode.parentNode.parentNode.parentNode;\n      var $clickedCard = $clickedButton.closest('.product-ingredients-card');\n      var $popupContent = $clickedCard.querySelector('template');\n      var $lastCard = this.cards[this.cards.length - 1];\n\n      // Obtenemos el offset de la tarjeta activa\n      var offsetLeft = $clickedCard.getBoundingClientRect().left;\n      var adjustment = 124;\n      if (window.innerWidth <= 680) {\n        adjustment = 0;\n      }\n\n      // recorremos todas las tarjetas y quitamos la clase 'active' excepto a la que acabamos de dar click.\n      this.cards.forEach($card => $card === $clickedCard ? false : $card.classList.remove('active'));\n\n      // qutamos o ponemos la clase active que acabamos de dar click.\n      $clickedCard.classList.toggle('active');\n\n      // llenamos el contentido del popup con el template de la tarjeta\n      this.$popup.innerHTML = $popupContent.innerHTML;\n\n      // ponemos el listener para el boton de cerrar el popup, ya que se destruira cada que remplazemos el html al hacer click en una nueva tarjeta.\n      this.$popup.querySelector('.close-button').addEventListener('click', this.closePopup.bind(this));\n\n      // porsicionamos correctamente el popup en su tarjeta activa, ya que el popup estara por fuera del slider.\n      if ($clickedCard === $lastCard) {\n        this.$popup.style.cssText = \"left: \".concat(offsetLeft - adjustment, \"px;\");\n      } else {\n        this.$popup.style.cssText = \"left: \".concat(offsetLeft + adjustment, \"px;\");\n      }\n\n      // mostramors el popup\n      this.$popup.classList.add('active');\n    }\n  },\n  closePopup() {\n    // funcion para cerr el popup\n    this.$popup.classList.remove('active');\n  }\n};\n\n// Se determina si ya se ha registrado la seccióno no.\nif (_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.registered[sectionType] == null) {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)(sectionType, sectionConfig);\n}\n\n// Debido a que esta seccion tambien se encuentra en la PDP\n// ponemos el listener para que recarge la seccion cuando se cambia de producto con el Product linking\ndocument.addEventListener('update::product_linking', () => {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.unregister)(sectionType);\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)(sectionType, sectionConfig);\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.load)(sectionType);\n});\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/templates/product/ingredients.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"product-ingredients": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/product/ingredients.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;